import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Card, CardContent } from '@/components/ui/card';

const RefundPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <div className="container mx-auto px-4 py-12 max-w-3xl flex-grow">
        <h1 className="text-3xl font-bold mb-8 text-center">Refund & Cancellation Policy</h1>
        
        <Card className="mb-8">
          <CardContent className="pt-6">
            <p className="mb-4">
              Last Updated: April 25, 2025
            </p>
            
            <div className="space-y-6">
              <div>
                <p className="mb-4">
                  At Krix.app, we are committed to providing a seamless and transparent experience. Our refund policy is designed to ensure customer satisfaction while maintaining the integrity of our service.
                </p>
              </div>
              
              <div>
                <h2 className="text-xl font-semibold mb-2">1. Legal Entity Information</h2>
                <p className="font-medium">Legal Entity Name: NXT BIZNESS SOLUTIONS</p>
                
                <p className="font-medium mt-4">Registered Address:</p>
                <p className="mb-2">402, 6-3-542/1, Golden Green Apartments,</p>
                <p className="mb-2">Panjagutta, Hyderabad, Telangana,</p>
                <p className="mb-2">India, PIN: 500082</p>
                
                <p className="font-medium mt-4">Operational Address:</p>
                <p className="mb-2">402, 6-3-542/1, Golden Green Apartments,</p>
                <p className="mb-2">Panjagutta, Hyderabad, Telangana,</p>
                <p className="mb-2">India, PIN: 500082</p>
                
                <p className="font-medium mt-4">Contact Details:</p>
                <p className="mb-2">Telephone: <a href="tel:+919885390929" className="text-primary hover:underline">+91 9885390929</a></p>
                <p className="mb-2">Email: <a href="mailto:support@krix.app" className="text-primary hover:underline">support@krix.app</a></p>
                
                <p className="mt-4">
                  By using our Services, you acknowledge that this Refund Policy is governed by NXT BIZNESS SOLUTIONS.
                </p>
              </div>
              
              <div>
                <h2 className="text-xl font-semibold mb-2">2. Cancellation Policy</h2>
                <p className="font-medium">Subscription Cancellations:</p>
                <ul className="list-disc pl-5 space-y-1 mt-2">
                  <li>You can cancel your subscription at any time through your account settings on Krix.app.</li>
                  <li>Cancellations will take effect at the end of the current billing cycle. You will retain access to the service until the end of the paid period, and no further charges will be made.</li>
                  <li>If you cancel during a free trial period, your access will end immediately, and no charges will be applied.</li>
                </ul>
              </div>
              
              <div>
                <h2 className="text-xl font-semibold mb-2">3. Refund Eligibility</h2>
                <p className="mb-2">Refunds are available under the following circumstances:</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li><strong>7-Day Money-Back Guarantee:</strong> If you are unsatisfied with our service for any reason, you can request a full refund within 7 days of your initial purchase.</li>
                  <li><strong>Technical Issues:</strong> If you experience persistent technical problems that prevent you from using the service and our support team is unable to resolve the issue within a reasonable timeframe.</li>
                  <li><strong>Service Not Delivered:</strong> If the subscription service you purchased was not delivered as promised or described on our website.</li>
                  <li><strong>Unauthorized Transactions:</strong> If a subscription charge was made without your authorization, and you report it within 7 days of the transaction.</li>
                </ul>
              </div>
              
              <div>
                <h2 className="text-xl font-semibold mb-2">4. Non-Refundable Scenarios</h2>
                <p className="mb-2">The following situations are not eligible for refunds:</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Subscription fees for the current billing cycle after the subscription has been used or partially used.</li>
                  <li>Cancellations made after the 7-day refund window.</li>
                  <li>Promotional or discounted subscriptions, unless otherwise specified.</li>
                  <li>Requests that do not fall under the specified refund eligibility criteria.</li>
                </ul>
              </div>
              
              <div>
                <h2 className="text-xl font-semibold mb-2">5. Refund Process</h2>
                <ul className="list-disc pl-5 space-y-1">
                  <li>To request a refund, please contact our Customer Support Team at <a href="mailto:support@krix.app" className="text-primary hover:underline">support@krix.app</a> with your subscription details and a description of the issue.</li>
                  <li>Refund requests must be submitted within 7 days of the transaction date.</li>
                  <li>Once your refund request is approved, the amount will be processed and credited to your original payment method within 7-10 business days.</li>
                </ul>
              </div>
              
              <div>
                <h2 className="text-xl font-semibold mb-2">6. Free Trials</h2>
                <p>If you cancel during a free trial period, you will not be charged. However, if you do not cancel before the trial period ends, the subscription will automatically renew, and the applicable charges will apply.</p>
              </div>
              
              <div>
                <h2 className="text-xl font-semibold mb-2">7. Contact Us</h2>
                <p className="mb-2">If you have any questions or concerns about this Refund Policy, please contact us using the details below:</p>
                <p className="mb-2">Telephone: <a href="tel:+919885390929" className="text-primary hover:underline">+91 9885390929</a></p>
                <p className="mb-2">Email: <a href="mailto:support@krix.app" className="text-primary hover:underline">support@krix.app</a></p>
                <p className="font-medium mt-2">Address:</p>
                <p className="mb-2">402, 6-3-542/1, Golden Green Apartments,</p>
                <p className="mb-2">Panjagutta, Hyderabad, Telangana,</p>
                <p className="mb-2">India, PIN: 500082</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
      
      <Footer />
    </div>
  );
};

export default RefundPage;
